import React, { memo } from 'react';
import { useAppSelector } from 'store/hooks';
import { generalState } from 'store/slices';
import { LoginDialog } from './login/LoginDialog';
import { ResetPasswordDialog } from './reset-password/ResetPasswordDialog';

export const ApplicationDialogs = memo(() => {
  const {
    featureFlags: { isMarketplaceV2Enabled }
  } = useAppSelector(generalState);

  if (!isMarketplaceV2Enabled) return <></>;

  return (
    <>
      <LoginDialog />
      <ResetPasswordDialog />
    </>
  );
});
